<template>
	<view class="content-title">
		<!-- <view class="titleName">{{title}}</view> -->
		<slot></slot>
		<!-- <image v-if="isHavBack" @click="goback" class="backIcon" src="../../static/image/backIcon.png" mode="aspectFill"></image> -->
	</view>
</template>

<script>
	export default {
		props:{
			title: String,
			isHavBack: Boolean
		},
		data() {
			return {
				
			}
		},
		methods: {
			goback() {
				uni.navigateBack()
			}
		},
		mounted() {
			console.log('title',this.title)
		}
	}
</script>

<style lang="scss" scoped>
  .content-title{
		width: 100%;
		height: 176rpx;
		background-color: #1F9F4C;
		position: relative;
		.titleName{
			color: #FFFFFF;
			line-height: 88rpx;
			padding-top: 88rpx;
			padding-left: 32rpx;
			letter-spacing: 3rpx;
			font-weight: lighter;
			text-align: center;
		}
		.backIcon{
			position: absolute;
			left: 20rpx;
			top:100rpx;
			width: 48rpx;
			height: 48rpx;
		}
	}
	
</style>
